import CommunicationsMessageRouteBase from 'garaje/helpers/communications/message-log/show/route-base';

export default class CommunicationsMessageRoute extends CommunicationsMessageRouteBase {}
